module.exports = __webpack_public_path__ + "static/media/quote-daskal-greatness.f2ea978e.png";